import React, { useMemo, useState } from "react";
import InputMask from "react-input-mask";

import Popover from "@mui/material/Popover";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import DateRangeCalendar from "./DateRangeCalendar";

import { CalendarIcon } from "@mui/x-date-pickers";

import { DateRangeValue } from "./types";

import isBetween from "dayjs/plugin/isBetween";
import dayjs from "dayjs";

dayjs.extend(isBetween);

const DATE_FORMAT = "DD.MM.YYYY";
const MASK = "99.99.9999 - 99.99.9999";

interface DateRangePickerProps {
  value?: DateRangeValue | null;
  onClick?: () => void;
  onSubmit?: (value: DateRangeValue | null) => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = (props) => {
  const { value, onClick, onSubmit } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const inputValue = useMemo(() => {
    return `${value?.from?.format(DATE_FORMAT)} - ${value?.to?.format(
      DATE_FORMAT
    )}`;
  }, [value]);

  const handleOpen = (event: React.MouseEvent<HTMLDivElement>) => {
    onClick?.();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onAccept = (value: DateRangeValue | null) => {
    onSubmit?.(value);
    handleClose();
  };

  const handleCancel = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <InputMask
        mask={MASK}
        value={inputValue}
        onClick={handleOpen}
        maskChar={null}
        readOnly
        placeholder="Вкажіть діапазон дат"
      >
        {(inputMaskProps) => (
          <TextField
            data-testid="date-range-picker"
            {...inputMaskProps}
            fullWidth
            slotProps={{
              input: {
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <CalendarIcon />
                  </InputAdornment>
                ),
              },
            }}
          />
        )}
      </InputMask>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <DateRangeCalendar
          value={value}
          onAccept={onAccept}
          onCancel={handleCancel}
        />
      </Popover>
    </>
  );
};

export default React.memo(DateRangePicker);
